import graphql__1aafa70f067f2e67d411 from "./__generated__/ContributionsListWithNavigation_participativeModule.graphql.js";import { Suspense } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import ContributionsListNavigationWithFilters from "./ContributionsListNavigationWithFilters";
import ContributionDetailsModalManager from "./ContributionDetailsModalManager";
import { Desktop, NonDesktop } from "../../Utils/ResponsiveQueries";

import { useFormatMessage } from "../../Intl/Context";
import { getContributionsAnchorId } from "../../Utils/anchorIds";
import AnchorTarget from "../../Utils/AnchorTarget";
import { ResourcesListProvider } from "../../ResourcesList/resourcesList";
import ResourcesListUrlSearchSync from "../../ResourcesList/ResourcesListUrlSearchSync";
import ContributionsList from "./ContributionsList";
import Icon from "../../Utils/Icon";
import { BoxSpinner } from "../../Utils/Spinner";
import ModalOutlet from "../../Routing/ModalOutlet";

const ContributionsListWithNavigation = props => {
  const participativeModule = useFragment(
    ContributionsListWithNavigation_participativeModule,
    props.participativeModule
  );

  const t = useFormatMessage();
  const listTitle = t(intlMessages.listTitle);
  const contributionsAnchorId = getContributionsAnchorId(participativeModule.slug);

  return (
    <ResourcesListProvider>
      <ResourcesListUrlSearchSync />
      <div className="container participative-module-container">
        <div className="contributions-list">
          <AnchorTarget id={contributionsAnchorId} />

          <div className="box margin-bottom-xs">
            <div className="contributions-list-title height-lg padding-y-md padding-x-sm text-title-section with-icon">
              <Icon className="text-primary icon-debate" />
              <h2 className="with-icon-text text-subtitle-page font-weight-bold">
                {listTitle}
              </h2>
            </div>
          </div>

          <Desktop>
            <div className="row">
              <div className="col-md-4">
                <ContributionsListNavigationWithFilters
                  participativeModule={participativeModule}
                />
              </div>

              <div className="col-md-8">
                <Suspense fallback={<BoxSpinner />}>
                  <ContributionsList
                    participativeModule={participativeModule}
                    hasNavigation={true}
                  />
                </Suspense>
              </div>
            </div>
          </Desktop>

          <NonDesktop>
            <ContributionsListNavigationWithFilters
              participativeModule={participativeModule}
            />

            <ContributionDetailsModalManager />
          </NonDesktop>
        </div>
      </div>

      <ModalOutlet />
    </ResourcesListProvider>
  );
};

const ContributionsListWithNavigation_participativeModule = graphql__1aafa70f067f2e67d411;

export default ContributionsListWithNavigation;

const intlMessages = defineMessages({
  listTitle: {
    id: "participativeModule.contributionsList.listTitle",
    defaultMessage: "Les contributions"
  }
});
